import Plyr from 'plyr';

document.addEventListener('DOMContentLoaded', ()=>{

    const videoWrappers = document.querySelectorAll('.section-video-wrapper');

    if (videoWrappers.length > 0) {
        const players = Plyr.setup('.js-player', {
            controls: ['play', 'progress', 'current-time', 'duration', 'mute', 'volume', 'settings'],
            fullscreen: {enabled: false},
            settings: []
        });

        players.forEach(player =>{
            const videoWrapper = player.elements.wrapper;
            const videoContainer = player.elements.container;

            videoContainer.setAttribute('tabindex', '0');

            const videoWrapperParent = videoWrapper.closest('.section-video-wrapper');


            const playButton = videoWrapperParent.querySelector('.js-play-button');

            playButton.addEventListener('click',(e)=>{
                e.preventDefault();
                player.togglePlay();

                setTimeout(() => {
                    videoContainer.focus();
                }, 100);
            })

            player.on('ended', ()=>{
                videoContainer.classList.add('plyr--stopped');
            })
        })
    }

})